/*
 * QikTruck Widget - embeddable delivery quote/booking launcher.
 *
 * Install (paste-a-script, GA/Hotjar style):
 *   <script src="https://cdn.qiktruck.co.za/widget.js"
 *           data-qt-site="qt_pub_xxx"
 *           data-qt-mode="bubble"></script>
 *
 * No secret key lives in the page. The merchant activates + verifies their
 * domain in customer-hq; the public site id only selects config. Quoting is
 * shown in-context, but contact/payment/booking are handed over to
 * qiktruck.co.za (loaded in an isolated modal iframe), so this script never
 * touches money, secrets or PII.
 */
(function () {
  "use strict";

  if (window.QikTruck && window.QikTruck.__loaded) return;

  var DEFAULTS = {
    site: "",
    // Public quote/booking flow hosted by QikTruck (the "hosted checkout").
    quoteUrl: "https://www.qiktruck.co.za/widget/quote",
    // Public delivery API base (used by future in-widget live rates).
    apiBase: "https://api.qiktruck.co.za",
    mode: "bubble", // "bubble" | "inline" | "button"
    target: "[data-qt-widget]", // mount point for inline mode
    label: "Get a delivery price",
    // Appearance
    color: "#72574d", // launcher / accent background
    textColor: "#ffffff", // launcher text
    radius: "999px", // launcher corner radius
    position: "br", // bubble corner: br | bl | tr | tl
    size: "md", // sm | md | lg launcher size
    inlineHeight: 640, // px height for inline mode
    // Optional prefill passed through to the hosted quote flow.
    title: "",
    subtitle: "",
    description: "",
    category: "",
    promocode: "",
    truckType: "",
    email: "",
    mobile: "",
    firstname: "",
    lastname: "",
    autoQuote: null,
    pickup: null, // { lat, lng } or { address }
    warehouse: "", // partner_settings warehouse id (wh_…)
    destination: null, // { lat, lng, address? }
  };

  var POSITIONS = {
    br: { right: "20px", bottom: "20px" },
    bl: { left: "20px", bottom: "20px" },
    tr: { right: "20px", top: "20px" },
    tl: { left: "20px", top: "20px" },
  };
  var SIZES = {
    sm: { padding: "10px 16px", font: "14px" },
    md: { padding: "14px 20px", font: "15px" },
    lg: { padding: "18px 26px", font: "17px" },
  };

  function readScriptConfig() {
    var s =
      document.currentScript ||
      (function () {
        var all = document.getElementsByTagName("script");
        for (var i = all.length - 1; i >= 0; i--) {
          if ((all[i].src || "").indexOf("qiktruck-widget") !== -1 ||
              (all[i].getAttribute("data-qt-site"))) {
            return all[i];
          }
        }
        return null;
      })();
    var cfg = {};
    if (s) {
      var map = {
        "data-qt-site": "site",
        "data-qt-quote-url": "quoteUrl",
        "data-qt-api-base": "apiBase",
        "data-qt-mode": "mode",
        "data-qt-target": "target",
        "data-qt-label": "label",
        "data-qt-color": "color",
        "data-qt-text-color": "textColor",
        "data-qt-radius": "radius",
        "data-qt-position": "position",
        "data-qt-size": "size",
        "data-qt-inline-height": "inlineHeight",
        "data-qt-description": "description",
        "data-qt-title": "title",
        "data-qt-subtitle": "subtitle",
        "data-qt-category": "category",
        "data-qt-promocode": "promocode",
        "data-qt-trucktype": "truckType",
        "data-qt-email": "email",
        "data-qt-mobile": "mobile",
        "data-qt-firstname": "firstname",
        "data-qt-lastname": "lastname",
        "data-qt-autoquote": "autoQuote",
        "data-qt-sandbox": "sandbox",
        "data-qt-warehouse": "warehouse",
      };
      Object.keys(map).forEach(function (attr) {
        var v = s.getAttribute(attr);
        if (v != null && v !== "") cfg[map[attr]] = v;
      });
      var items = s.getAttribute("data-qt-items");
      if (items) {
        try {
          cfg.items = JSON.parse(items);
        } catch (e) {
          /* ignore malformed items */
        }
      }
    }
    return cfg;
  }

  function merge() {
    var out = {};
    for (var i = 0; i < arguments.length; i++) {
      var src = arguments[i] || {};
      for (var k in src) {
        if (Object.prototype.hasOwnProperty.call(src, k) && src[k] != null) {
          out[k] = src[k];
        }
      }
    }
    return out;
  }

  function truthy(v) {
    if (v == null || v === "") return false;
    var s = String(v).toLowerCase();
    return s !== "0" && s !== "false" && s !== "no";
  }

  function isSandboxMode(cfg) {
    return truthy(cfg && cfg.sandbox);
  }

  function sandboxBadgeHtml() {
    return (
      '<span class="qt-w-test-badge" aria-hidden="true">TEST</span>'
    );
  }

  function appendPrefillParams(params, cfg) {
    if (cfg.title) params.set("wt_title", cfg.title);
    if (cfg.subtitle) params.set("wt_subtitle", cfg.subtitle);
    if (cfg.description) {
      params.set("description", cfg.description);
      params.set("wt_item", cfg.description);
    }
    if (cfg.color) params.set("wt_color", cfg.color);
    if (cfg.category) params.set("category", cfg.category);
    if (cfg.promocode) params.set("promocode", cfg.promocode);
    if (cfg.truckType) params.set("trucktype", cfg.truckType);
    if (cfg.email) params.set("email", cfg.email);
    if (cfg.mobile) params.set("mobile", cfg.mobile);
    if (cfg.firstname) params.set("firstname", cfg.firstname);
    if (cfg.lastname) params.set("lastname", cfg.lastname);
    if (cfg.autoQuote != null && cfg.autoQuote !== "") params.set("autoquote", cfg.autoQuote);
    if (cfg.warehouse) params.set("warehouse", cfg.warehouse);
    if (cfg.pickup && cfg.pickup.lat != null) {
      params.set("collectionlat", cfg.pickup.lat);
      params.set("collectionlng", cfg.pickup.lng);
    }
    if (cfg.destination && cfg.destination.lat != null) {
      params.set("deliverylat", cfg.destination.lat);
      params.set("deliverylng", cfg.destination.lng);
    }
    if (cfg.destination && cfg.destination.address) {
      params.set("deliveryaddress", cfg.destination.address);
    }
    if (cfg.sandbox != null && cfg.sandbox !== "") {
      params.set("sandbox", truthy(cfg.sandbox) ? "1" : "0");
    }
  }

  function buildQuoteHref(cfg) {
    var params = new URLSearchParams();
    if (cfg.site) params.set("site", cfg.site);
    var srcPrefix = cfg.sandbox && truthy(cfg.sandbox) ? "widget_sandbox:" : "widget:";
    params.set("source_", srcPrefix + (cfg.site || "anon"));
    appendPrefillParams(params, cfg);
    var base = cfg.quoteUrl;
    var sep = base.indexOf("?") === -1 ? "?" : "&";
    return base + sep + params.toString();
  }

  var state = {
    cfg: null,
    overlay: null,
    iframe: null,
    launcher: null,
    open: false,
  };

  function injectBaseStyles() {
    if (document.getElementById("qt-widget-styles")) return;
    var css =
      ".qt-w-launch{position:fixed;z-index:2147483000;right:20px;bottom:20px;" +
      "display:inline-flex;align-items:center;gap:8px;border:0;border-radius:999px;" +
      "padding:14px 20px;font:600 15px/1 -apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;" +
      "color:#fff;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,.18);}" +
      ".qt-w-launch--sandbox{box-shadow:0 8px 24px rgba(217,119,6,.35),0 0 0 2px #fbbf24;}" +
      ".qt-w-test-badge{display:inline-block;padding:2px 7px;border-radius:999px;" +
      "background:#fbbf24;color:#78350f;font-size:10px;font-weight:800;letter-spacing:.08em;" +
      "line-height:1.2;vertical-align:middle;}" +
      ".qt-w-launch:hover{filter:brightness(1.05);}" +
      ".qt-w-launch--inline{position:static;right:auto;bottom:auto;}" +
      ".qt-w-overlay{position:fixed;inset:0;z-index:2147483001;background:rgba(15,23,42,.55);" +
      "display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;" +
      "transition:opacity .15s ease;}" +
      ".qt-w-overlay.is-open{opacity:1;}" +
      ".qt-w-modal{position:relative;width:100%;max-width:480px;height:86vh;max-height:760px;" +
      "background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.35);" +
      "display:flex;flex-direction:column;}" +
      ".qt-w-modal--sandbox{box-shadow:0 24px 64px rgba(0,0,0,.35),0 0 0 3px #f59e0b;}" +
      ".qt-w-test-bar{flex-shrink:0;display:flex;align-items:center;gap:8px;padding:8px 44px 8px 12px;" +
      "background:linear-gradient(90deg,#f59e0b,#d97706);color:#fff;font:600 12px/1.35 -apple-system,Segoe UI,Roboto,sans-serif;}" +
      ".qt-w-test-bar strong{font-weight:800;letter-spacing:.06em;}" +
      ".qt-w-frame-wrap{flex:1;min-height:0;position:relative;}" +
      ".qt-w-close{position:absolute;top:10px;right:12px;z-index:2;width:32px;height:32px;border:0;" +
      "border-radius:999px;background:rgba(255,255,255,.9);cursor:pointer;font-size:18px;line-height:1;}" +
      ".qt-w-frame{border:0;width:100%;height:100%;display:block;}" +
      ".qt-w-inline-test{margin:0 0 8px;padding:8px 12px;border-radius:10px;" +
      "background:linear-gradient(90deg,#f59e0b,#d97706);color:#fff;font:600 12px/1.35 -apple-system,sans-serif;}" +
      ".qt-w-inline-test strong{letter-spacing:.06em;}" +
      "@media(max-width:520px){.qt-w-modal{max-width:none;height:100%;max-height:none;border-radius:0;}}";
    var el = document.createElement("style");
    el.id = "qt-widget-styles";
    el.textContent = css;
    document.head.appendChild(el);
  }

  function openModal(overrides) {
    if (overrides) {
      state.cfg = merge(state.cfg, overrides);
    }
    if (state.open && state.iframe) {
      state.iframe.src = buildQuoteHref(state.cfg);
      return;
    }
    if (state.open) return;
    var overlay = document.createElement("div");
    overlay.className = "qt-w-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "QikTruck delivery quote");

    var modal = document.createElement("div");
    modal.className = "qt-w-modal" + (isSandboxMode(state.cfg) ? " qt-w-modal--sandbox" : "");

    var close = document.createElement("button");
    close.className = "qt-w-close";
    close.setAttribute("aria-label", "Close");
    close.innerHTML = "&times;";
    close.addEventListener("click", closeModal);

    if (isSandboxMode(state.cfg)) {
      var testBar = document.createElement("div");
      testBar.className = "qt-w-test-bar";
      testBar.setAttribute("role", "status");
      testBar.innerHTML =
        "<strong>TEST WIDGET</strong><span>Real prices + practice booking — no live trips</span>";
      modal.appendChild(testBar);
    }

    var frameWrap = document.createElement("div");
    frameWrap.className = "qt-w-frame-wrap";

    var iframe = document.createElement("iframe");
    iframe.className = "qt-w-frame";
    iframe.title = isSandboxMode(state.cfg)
      ? "QikTruck test delivery quote"
      : "QikTruck delivery quote";
    iframe.allow = "geolocation";
    iframe.src = buildQuoteHref(state.cfg);

    frameWrap.appendChild(iframe);
    modal.appendChild(close);
    modal.appendChild(frameWrap);
    overlay.appendChild(modal);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeModal();
    });
    document.body.appendChild(overlay);
    requestAnimationFrame(function () {
      overlay.classList.add("is-open");
    });

    state.overlay = overlay;
    state.iframe = iframe;
    state.open = true;
    document.addEventListener("keydown", onKeydown);
  }

  function closeModal() {
    if (!state.open) return;
    document.removeEventListener("keydown", onKeydown);
    if (state.overlay && state.overlay.parentNode) {
      state.overlay.parentNode.removeChild(state.overlay);
    }
    state.overlay = null;
    state.iframe = null;
    state.open = false;
  }

  function onKeydown(e) {
    if (e.key === "Escape") closeModal();
  }

  function onMessage(e) {
    var data = e && e.data;
    if (!data || typeof data !== "object") return;
    if (data.type === "qiktruck:close") closeModal();
    if (data.type === "qiktruck:quoted") {
      try {
        if (typeof state.cfg.onQuoted === "function") state.cfg.onQuoted(data);
      } catch (err) {
        /* host callback errors are non-fatal */
      }
    }
    if (data.type === "qiktruck:booked") {
      try {
        if (typeof state.cfg.onBooked === "function") state.cfg.onBooked(data);
      } catch (err) {
        /* host callback errors are non-fatal */
      }
    }
  }

  function bindOpenHooks() {
    // Any element with data-qt-open opens the widget - works in every mode so a
    // merchant can trigger it from their own "Add delivery" buttons.
    var hooks = document.querySelectorAll("[data-qt-open]");
    for (var i = 0; i < hooks.length; i++) {
      if (hooks[i].__qtBound) continue;
      hooks[i].__qtBound = true;
      hooks[i].addEventListener("click", function (e) {
        e.preventDefault();
        openModal();
      });
    }
    return hooks.length;
  }

  function makeLauncherButton(cfg, inline) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "qt-w-launch" + (inline ? " qt-w-launch--inline" : "");
    var size = SIZES[cfg.size] || SIZES.md;
    btn.style.background = cfg.color;
    btn.style.color = cfg.textColor;
    btn.style.borderRadius = cfg.radius;
    btn.style.padding = size.padding;
    btn.style.fontSize = size.font;
    if (!inline) {
      var pos = POSITIONS[cfg.position] || POSITIONS.br;
      btn.style.top = btn.style.right = btn.style.bottom = btn.style.left = "auto";
      Object.keys(pos).forEach(function (k) {
        btn.style[k] = pos[k];
      });
    }
    btn.innerHTML =
      (isSandboxMode(cfg) ? sandboxBadgeHtml() : "") +
      '<span aria-hidden="true">\uD83D\uDE9A</span><span>' +
      escapeHtml(cfg.label) +
      "</span>";
    if (isSandboxMode(cfg)) {
      btn.classList.add("qt-w-launch--sandbox");
      btn.setAttribute("aria-label", cfg.label + " (test widget)");
    }
    btn.addEventListener("click", openModal);
    return btn;
  }

  // True inline mode: render the quote flow directly in the page (no popup).
  function renderInline(cfg, target) {
    var wrap = document.createElement("div");
    wrap.className = "qt-w-inline";
    if (isSandboxMode(cfg)) {
      var testBar = document.createElement("div");
      testBar.className = "qt-w-inline-test";
      testBar.setAttribute("role", "status");
      testBar.innerHTML =
        "<strong>TEST WIDGET</strong> - real prices only; bookings won't create trips";
      wrap.appendChild(testBar);
    }
    var iframe = document.createElement("iframe");
    iframe.className = "qt-w-frame";
    iframe.title = "QikTruck delivery quote";
    iframe.allow = "geolocation";
    iframe.style.width = "100%";
    iframe.style.height = (parseInt(cfg.inlineHeight, 10) || 640) + "px";
    iframe.style.border = "0";
    iframe.src = buildQuoteHref(cfg);
    wrap.appendChild(iframe);
    target.appendChild(wrap);
    state.iframe = iframe;
  }

  function renderLauncher() {
    var cfg = state.cfg;
    var hookCount = bindOpenHooks();

    if (cfg.mode === "inline") {
      var target =
        typeof cfg.target === "string"
          ? document.querySelector(cfg.target)
          : cfg.target;
      if (target) {
        // Render the quote flow directly inline (no popup).
        renderInline(cfg, target);
        return;
      }
      // fall through to floating if the target is missing
    }

    if (cfg.mode === "button" && hookCount) {
      // merchant supplied their own trigger(s); no floating button needed
      return;
    }

    state.launcher = makeLauncherButton(cfg, false);
    document.body.appendChild(state.launcher);
  }

  function applySandboxLauncherChrome() {
    if (!state.launcher) return;
    var cfg = state.cfg;
    var sandbox = isSandboxMode(cfg);
    state.launcher.classList.toggle("qt-w-launch--sandbox", sandbox);
    var size = SIZES[cfg.size] || SIZES.md;
    state.launcher.innerHTML =
      (sandbox ? sandboxBadgeHtml() : "") +
      '<span aria-hidden="true">\uD83D\uDE9A</span><span>' +
      escapeHtml(cfg.label) +
      "</span>";
    state.launcher.style.background = cfg.color;
    state.launcher.style.color = cfg.textColor;
    state.launcher.style.borderRadius = cfg.radius;
    state.launcher.style.padding = size.padding;
    state.launcher.style.fontSize = size.font;
    if (sandbox) {
      state.launcher.setAttribute("aria-label", cfg.label + " (test widget)");
    } else {
      state.launcher.removeAttribute("aria-label");
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[c];
    });
  }

  // Pull the merchant's saved config (warehouse pickup, quote url, defaults) so
  // they configure it once in customer-hq instead of per page. Best-effort.
  function fetchRemoteConfig(cfg) {
    if (!cfg.site || !cfg.apiBase || typeof fetch !== "function") {
      return Promise.resolve();
    }
    var url = cfg.apiBase.replace(/\/$/, "") + "/widget/config?site=" + encodeURIComponent(cfg.site);
    return fetch(url, { credentials: "omit" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (remote) {
        if (!remote) return;
        if (remote.quote_url && !cfg.__quoteUrlOverridden) cfg.quoteUrl = remote.quote_url;
        if (remote.pickup && remote.pickup.lat != null && !cfg.pickup) {
          cfg.pickup = { lat: remote.pickup.lat, lng: remote.pickup.lng };
        }
        if (remote.defaults) {
          if (!cfg.category && remote.defaults.category) cfg.category = remote.defaults.category;
          // Merchant's default promo code (QikTruck can fund the discount) so the
          // shopper sees a cheaper price automatically.
          if (!cfg.promocode && remote.defaults.promocode) cfg.promocode = remote.defaults.promocode;
        }
        if (remote.sandbox === true) cfg.sandbox = true;
        if (remote.widget_live_enabled === true) cfg.sandbox = false;
        applySandboxLauncherChrome();
      })
      .catch(function () {
        /* config is optional; widget still works via the hosted flow */
      });
  }

  function init(userCfg) {
    var scriptCfg = readScriptConfig();
    state.cfg = merge(DEFAULTS, scriptCfg, userCfg || window.QikTruckWidgetConfig);
    // Track whether the host explicitly set a quote url so remote config can't clobber it.
    state.cfg.__quoteUrlOverridden =
      !!(scriptCfg.quoteUrl || (userCfg && userCfg.quoteUrl) ||
        (window.QikTruckWidgetConfig && window.QikTruckWidgetConfig.quoteUrl));
    injectBaseStyles();
    window.removeEventListener("message", onMessage);
    window.addEventListener("message", onMessage);

    var start = function () {
      fetchRemoteConfig(state.cfg).then(renderLauncher);
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else {
      start();
    }
    return window.QikTruck;
  }

  window.QikTruck = {
    __loaded: true,
    init: init,
    open: openModal,
    close: closeModal,
    update: function (partial) {
      state.cfg = merge(state.cfg, partial || {});
      applySandboxLauncherChrome();
      if (state.open && state.iframe) {
        state.iframe.src = buildQuoteHref(state.cfg);
      }
      return state.cfg;
    },
    config: function () {
      return state.cfg;
    },
  };

  // Auto-init when embedded via <script data-qt-site=...> or a global config.
  var auto = readScriptConfig();
  if ((auto && auto.site) || window.QikTruckWidgetConfig) {
    init();
  }
})();
